import React from 'react';
import GameplaySection from '../GameplaySection/GameplaySection';
import GameSkeleton, { DailyChallengeLoadingScreen } from '../GameSkeleton/GameSkeleton';

const GameplayHydrateFallback: React.FC<{
  mode: 'quiz' | 'daily' | 'endless';
}> = ({ mode }) => (
  <GameplaySection className="px-5 md:px-10 md:pb-8">
    {mode === 'daily' ? (
      <DailyChallengeLoadingScreen />
    ) : (
      <GameSkeleton
        mode={mode}
        showGenerationTag={mode !== 'quiz'}
        stablePresentation={mode === 'quiz'}
      />
    )}
  </GameplaySection>
);

export const DailyHydrateFallback: React.FC = () => <GameplayHydrateFallback mode="daily" />;

export const EndlessHydrateFallback: React.FC = () => <GameplayHydrateFallback mode="endless" />;

export const QuizHydrateFallback: React.FC = () => <GameplayHydrateFallback mode="quiz" />;
